import { Select } from "@/components/ui/select"

export type ProgramOption = { id: number; name: string }

/**
 * Picks which program new official content belongs to. Renders nothing when
 * there is nothing to choose between; the server then uses the only program.
 */
export function ProgramSelect({
  id,
  programs,
  value,
  onChange,
  error,
}: {
  id: string
  programs: ProgramOption[]
  value: string
  onChange: (value: string) => void
  error?: string
}) {
  if (programs.length < 2 && !error) return null

  return (
    <div className="space-y-2">
      {programs.length > 1 && (
        <>
          <label htmlFor={id}>Program</label>
          <Select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
            {programs.map((program) => (
              <option key={program.id} value={program.id}>
                {program.name}
              </option>
            ))}
          </Select>
        </>
      )}
      {error && <p className="text-xs text-danger-display">{error}</p>}
    </div>
  )
}
